import { useNavigate } from "react-router-dom";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { useEffect, useState } from "react";
import Modal from "../../components/modal/modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/table/table";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
import ToggleSwitch from "../../components/toggleSwitch";
import { addUpdateApi, getAllApi, uploadImageApi } from "../../api";
import he from "he";
import toast from "react-hot-toast";
import { isValidURL } from "../../utils/isValidUrl";

const Career = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [deleteFrom, setDeleteFrom] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [modal, setModal] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [hero, setHero] = useState([]);
  const [fold1Title, setFold1Title] = useState("");
  const [fold1Description, setFold1Description] = useState("");
  const [fold2List, setFold2List] = useState([]);
  const [fold3Heading, setFold3Heading] = useState("");
  const [fold3BtnShow, setFold3BtnShow] = useState("");
  const [fold3BtnText, setFold3BtnText] = useState("");
  const [fold3BtnLink, setFold3BtnLink] = useState("");
  const [fold3Description, setFold3Description] = useState("");
  const [fold3Image, setFold3Image] = useState({ url: "", obj: "" });
  const [fold3ImageCaption, setFold3ImageCaption] = useState("");
  const [fold3ImageAlt, setFold3ImageAlt] = useState("");
  const [fold4Image, setFold4Image] = useState({ url: "", obj: "" });
  const [fold4ImageCaption, setFold4ImageCaption] = useState("");
  const [fold4ImageAlt, setFold4ImageAlt] = useState("");
  const [fold4Title, setFold4Title] = useState("");
  const [fold4Description, setFold4Description] = useState("");
  const [fold4BtnShow, setFold4BtnShow] = useState(false);
  const [fold4BtnText, setFold4BtnText] = useState("");
  const [fold4BtnLink, setFold4BtnLink] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [slug, setSlug] = useState("");
  const [metaImageUrl, setMetaImageUrl] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getAllApi("career")
      .then((res) => {
        if (res.data.length !== 0) {
          const v = res.data[0];
          setId(res.data[0]._id);
          setHero(
            res.data[0].heroCarousel.map((v) => ({
              ...v,
              image: { url: v.image, obj: "" },
            }))
          );
          setFold1Title(v.fold1.title);
          setFold1Description(he.decode(v.fold1.description));

          setFold2List(
            v.fold2.map((v) => ({
              ...v,
              icon: { url: v.icon, obj: "" },
              description: he.decode(v.description),
            }))
          );

          setFold3Image({ url: v.fold3.image, obj: "" });
          setFold3ImageCaption(v.fold3.imageCaptions);
          setFold3ImageAlt(v.fold3.imageAlt);
          setFold3Heading(v.fold3.heading);
          setFold3Description(he.decode(v.fold3.description));
          setFold3BtnShow(v.fold3.button);
          setFold3BtnText(v.fold3.buttonText);
          setFold3BtnLink(v.fold3.buttonUrl);

          setFold4Image({ url: v.fold4.image, obj: "" });
          setFold4ImageCaption(v.fold4.imageCaptions);
          setFold4ImageAlt(v.fold4.imageAlt);
          setFold4Title(v.fold4.heading);
          setFold4Description(he.decode(v.fold4.description));
          setFold4BtnShow(v.fold4.button);
          setFold4BtnText(v.fold4.buttonText);
          setFold4BtnLink(v.fold4.buttonUrl);

          setSlug(v.metaData.slug);
          setMetaTitle(v.metaData.metaTitle);
          setMetaDescription(v.metaData.metaDescription);
          setMetaImageUrl(v.metaData.metaImageUrl);
          setCanonicalUrl(v.metaData.canonicalUrl);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleDelete = () => {};

  const getHeroData = async () => {
    let hd = [];
    for (let i = 0; i < hero.length; i++) {
      if (hero[i].image.obj) {
        const res = await uploadImageApi(hero[i].image?.obj, "technology");
        hd.push({
          image: res.data.imageUrl,
          imageCaption: hero[i].imageCaption,
          imageAlt: hero[i].imageAlt,
          content: hero[i].content,
          numbers: hero[i].numbers,
          showButton: hero[i].showButton,
          buttonText: hero[i].buttonText,
          buttonLink: hero[i].buttonLink,
        });
      } else {
        hd.push({
          image: hero[i].image.url,
          imageCaption: hero[i].imageCaption,
          imageAlt: hero[i].imageAlt,
          content: hero[i].content,
          numbers: hero[i].numbers,
          showButton: hero[i].showButton,
          buttonText: hero[i].buttonText,
          buttonLink: hero[i].buttonLink,
        });
      }
    }
    return hd;
  };

  const getFold2Data = async () => {
    let f2d = [];
    for (let i = 0; i < fold2List.length; i++) {
      if (fold2List[i].icon.obj) {
        const res = await uploadImageApi(fold2List[i].icon?.obj, "technology");
        f2d.push({
          icon: res.data.imageUrl,
          title: fold2List[i].title,
          description: fold2List[i].description,
          iconCaption: fold2List[i].iconCaption,
          iconAlt: fold2List[i].iconAlt,
        });
      } else {
        f2d.push({
          icon: fold2List[i].icon.url,
          title: fold2List[i].title,
          description: fold2List[i].description,
          iconCaption: fold2List[i].iconCaption,
          iconAlt: fold2List[i].iconAlt,
        });
      }
    }
    return f2d;
  };

  const validate = () => {
    const validationCheck = [
      // fold 1
      { condition: !fold1Title, message: "Fold 1 Title is required." },
      {
        condition: !fold1Description,
        message: "Fold 1 Description is required.",
      },
      // fold 2
      {
        condition: fold2List === 0,
        message: "Fold 2 is required.",
      },
      {
        condition: fold2List.some((v) => !v.icon.url),
        message: "Fold 2 Icon is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconCaption),
        message: "Fold 2 Icon Caption is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconAlt),
        message: "Fold 2 Icon Alt is required.",
      },
      {
        condition: fold2List.some((v) => !v.title),
        message: "Fold 2 list title is required.",
      },
      {
        condition: fold2List.some((v) => !v.description),
        message: "Fold 2 list description is required.",
      },
      // fold 3
      {
        condition: !fold3Image.url,
        message: "Fold 3 Image is required.",
      },
      {
        condition: !fold3ImageCaption,
        message: "Fold 3 Image caption is required.",
      },
      {
        condition: !fold3ImageAlt,
        message: "Fold 3 Image Alt is required.",
      },
      {
        condition: !fold3Heading,
        message: "Fold 3 Heading is required.",
      },
      {
        condition: !fold3Description,
        message: "Fold 3 Description is required.",
      },
      {
        condition: fold3BtnShow && !fold3BtnText,
        message: "Fold 3 Button Text is required",
      },
      {
        condition: fold3BtnShow && !fold3BtnLink,
        message: "Fold 3 Button Link is required.",
      },
      {
        condition: !isValidURL(fold3BtnLink),
        message: "Fold 3 Button Link is invalid url.",
      },
      //fold 4
      {
        condition: !fold4Image.url,
        message: "Fold 4 Image is required.",
      },
      {
        condition: !fold4ImageCaption,
        message: "Fold 4 Image caption is required.",
      },
      {
        condition: !fold4ImageAlt,
        message: "Fold 4 Image Alt is required.",
      },
      {
        condition: !fold4Title,
        message: "Fold 4 Heading is required.",
      },
      {
        condition: !fold4Description,
        message: "Fold 4 Description is required.",
      },
      {
        condition: fold4BtnShow && !fold4BtnText,
        message: "Fold 4 Button Text is required",
      },
      {
        condition: fold4BtnShow && !fold4BtnLink,
        message: "Fold 4 Button Link is required.",
      },
      {
        condition: !isValidURL(fold4BtnLink),
        message: "Fold 4 Button Link is invalid url.",
      },
      {
        condition: !slug,
        message: "Slug is required.",
      },
      {
        condition: !metaTitle,
        message: "Meta Title is required.",
      },
      {
        condition: !metaImageUrl,
        message: "Meta Image Url is required.",
      },
      {
        condition: !isValidURL(metaImageUrl),
        message: "Invalid Meta Image Url.",
      },
      {
        condition: !metaDescription,
        message: "Meta Description is required.",
      },
      {
        condition: !canonicalUrl,
        message: "Canonical Url is required.",
      },
      {
        condition: !isValidURL(canonicalUrl),
        message: "Invalid canonical url.",
      },
    ];

    for (const check of validationCheck) {
      if (check.condition) {
        toast.error(check.message);
        return false;
      }
    }

    return true;
  };

  const handleUpdate = async () => {
    if (validate()) {
      setLoading(true);

      const data = {
        heroCarousel: await getHeroData(),
        fold1: {
          title: fold1Title,
          description: fold1Description,
        },
        fold2: await getFold2Data(),
        fold3: {
          imageCaptions: fold3ImageCaption,
          imageAlt: fold3ImageAlt,
          heading: fold3Heading,
          description: fold3Description,
          button: fold3BtnShow,
          buttonText: fold3BtnText,
          buttonUrl: fold3BtnLink,
        },
        fold4: {
          heading: fold4Title,
          description: fold4Description,
          button: fold4BtnShow,
          buttonText: fold4BtnText,
          buttonUrl: fold4BtnLink,
          imageCaptions: fold4ImageCaption,
          imageAlt: fold4ImageAlt,
        },
        metaData: {
          slug,
          metaTitle,
          metaDescription,
          metaImageUrl,
          canonicalUrl,
        },
      };

      if (fold3Image.obj) {
        const r = await uploadImageApi(fold3Image.obj, "technology");
        data.fold3.image = r.data.imageUrl;
      } else {
        data.fold3.image = fold3Image.url;
      }

      if (fold4Image.obj) {
        const r = await uploadImageApi(fold4Image.obj, "technology");
        data.fold4.image = r.data.imageUrl;
      } else {
        data.fold4.image = fold4Image.url;
      }

      addUpdateApi({ data, type: "career", method: "patch", id })
        .then((res) => {
          toast.success("Updated Successfuly.");
          setIsChanged(false);
          getData();
        })
        .catch((err) => {
          toast.error(err.response.data.message);
          setLoading(false);
        });
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => {
          setDeleteFrom("");
          setDeleteId("");
          setModal(false);
        }}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <Content>
        <ContentHead
          title="Career"
          showBtn1={isChanged}
          btn1Text={"Save"}
          btn1type="filled"
          btn1Name="btn1"
          showBtn2={isChanged}
          btn2Text="Cancel"
          btn2type="outlined_del"
          btn2Name="btn2"
          onClickHandler={(e) => {
            if (e.target.name === "btn1") {
              handleUpdate();
            } else {
              //   setLoading(true);
              getData();
              setIsChanged(false);
            }
          }}
        />
        <ContentBody>
          <div className="grid">
            <div className="card grid">
              <h3>
                Hero{" "}
                <button
                  onClick={() => {
                    let temp = [...hero];
                    temp.push({
                      image: { url: "", obj: "" },
                      imageCaption: "",
                      imageAlt: "",
                      content: "",
                      numbers: [],
                      showButton: false,
                      buttonText: "",
                      buttonUrl: "",
                    });
                    setHero(temp);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              {hero.map((value, index) => {
                return (
                  <div key={index} className="sub_card grid">
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        let temp = [...hero];
                        temp.splice(index, 1);
                        setHero(temp);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {value.image.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...hero];
                              temp[index].image = { url: "", obj: "" };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={value.image.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              // let temp = [...fold2List];
                              // temp[index].icon = {
                              //   url: URL.createObjectURL(e.target.files[0]),
                              //   obj: e.target.files[0],
                              // };
                              // setFold2List(temp);
                              // setIsChanged(true);
                              let temp = [...hero];
                              temp[index].image = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {value.image?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={value.imageCaption}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageCaption = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={value.imageAlt}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageAlt = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <div className="grid_2">
                      <div
                        style={{
                          height: "50px",
                          width: "100%",
                          border: "1px solid lightgrey",
                          background: "white",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          paddingInline: "15px",
                          justifyContent: "space-between",
                          marginTop: "25px",
                        }}
                      >
                        <p>Show Button</p>
                        <ToggleSwitch
                          value={value?.showButton}
                          onClick={() => {
                            let temp = [...hero];
                            temp[index].showButton = !value?.showButton;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                      {value?.showButton && (
                        <>
                          <InputField
                            type="text"
                            isLabel={true}
                            lable="Button Text"
                            value={value?.buttonText}
                            onChange={(e) => {
                              let temp = [...hero];
                              temp[index].buttonText = e.target.value;
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <InputField
                            type="text"
                            isLabel={true}
                            lable="Button Link"
                            value={value?.buttonLink}
                            onChange={(e) => {
                              let temp = [...hero];
                              temp[index].buttonLink = e.target.value;
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                        </>
                      )}
                    </div>
                    <div className="grid">
                      <InputField
                        type="textarea"
                        isLabel={true}
                        lable={"Content"}
                        value={value.content}
                        onChange={(e) => {
                          let temp = [...hero];
                          temp[index].content = e.target.value;
                          setHero(temp);
                          setIsChanged(true);
                        }}
                      />
                    </div>
                    <h3>
                      Numbers{" "}
                      <button
                        onClick={() => {
                          const temp = [...hero];
                          temp[index].numbers.push({ title: "", number: "" });
                          setHero(temp);
                        }}
                        style={{
                          background: "var(--blue-light)",
                          border: "none",
                          padding: "3px 5px",
                        }}
                      >
                        <FontAwesomeIcon icon={faAdd} />
                        Add
                      </button>
                    </h3>
                    <div className="grid">
                      {value.numbers.map((v, i) => {
                        return (
                          <div
                            key={index}
                            className="sub_card grid_2"
                            style={{ borderWidth: "1px" }}
                          >
                            <FontAwesomeIcon
                              icon={faClose}
                              className="sub_card_close"
                              onClick={() => {
                                const temp = [...hero];
                                temp[index].numbers.splice(i, 1);
                                setHero(temp);
                              }}
                            />
                            <InputField
                              type="text"
                              isLabel={true}
                              lable={"Title"}
                              value={v.title}
                              onChange={(e) => {
                                const temp = [...hero];
                                temp[index].numbers[i].title = e.target.value;
                                setHero(temp);
                              }}
                            />
                            <InputField
                              type="number"
                              isLabel={true}
                              lable={"Number"}
                              value={v.number}
                              onChange={(e) => {
                                const temp = [...hero];
                                temp[index].numbers[i].number = e.target.value;
                                setHero(temp);
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="card grid">
              <h3>Fold 1</h3>
              <InputField
                type="text"
                isLabel={true}
                lable={"Title"}
                value={fold1Title}
                onChange={(e) => {
                  setIsChanged(true);
                  setFold1Title(e.target.value);
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setIsChanged(true);
                    setFold1Description(val);
                  }}
                  content={fold1Description}
                  smallEditor={true}
                />
              </div>
            </div>
            <div className="card grid">
              <h3>
                Fold 2{" "}
                <button
                  onClick={() => {
                    setFold2List((prev) => [
                      ...prev,
                      {
                        title: "",
                        icon: { url: "", obj: "" },
                        description: "",
                        iconCaption: "",
                        iconAlt: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold2List.map((value, index) => (
                <div key={index} className="sub_card grid">
                  <FontAwesomeIcon
                    icon={faClose}
                    className="sub_card_close"
                    onClick={() => {
                      let temp = fold2List;
                      temp.splice(index, 1);
                      setFold2List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div>
                    <p style={{ fontSize: ".9rem" }}>Image</p>
                    {value.icon.url ? (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                          position: "relative",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faClose}
                          style={{
                            color: "var(--blue-dark)",
                            cursor: "pointer",
                            height: "15px",
                            width: "15px",
                            padding: "5px",
                            position: "absolute",
                            top: 0,
                            right: 0,
                            transform: "translate(50%, -50%)",
                          }}
                          onClick={() => {
                            let temp = [...fold2List];
                            temp[index].icon = { url: "", obj: "" };
                            setFold2List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <img
                          src={value.icon.url}
                          alt=""
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          position: "relative",
                          background: "var(--blue-light)",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "5px",
                        }}
                      >
                        <input
                          type="file"
                          style={{
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            opacity: 0,
                          }}
                          accept="image/*"
                          onChange={(e) => {
                            let temp = [...fold2List];
                            temp[index].icon = {
                              url: URL.createObjectURL(e.target.files[0]),
                              obj: e.target.files[0],
                            };
                            setFold2List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ color: "var(--blue-dark)" }}
                        />
                      </div>
                    )}
                  </div>
                  {value.icon?.url && (
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Caption"}
                        value={value.iconCaption}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconCaption = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Alt"}
                        value={value.iconAlt}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconAlt = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                    </div>
                  )}
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={value.title}
                    onChange={(e) => {
                      let temp = fold2List;
                      temp[index].title = e.target.value;
                      setFold2List([...temp]);
                      setIsChanged(true);
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <p style={{ paddingLeft: "5px" }}>Description</p>
                    <TextEditor
                      handleChange={(val) => {
                        let temp = fold2List;
                        temp[index].description = val;
                        setFold2List([...temp]);
                        setIsChanged(true);
                      }}
                      content={value.description}
                      smallEditor={true}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="card grid">
              <h3>Fold 3</h3>
              <div>
                <p style={{ fontSize: ".9rem" }}>Image</p>
                {fold3Image.url ? (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                      position: "relative",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faClose}
                      style={{
                        color: "var(--blue-dark)",
                        cursor: "pointer",
                        height: "15px",
                        width: "15px",
                        padding: "5px",
                        position: "absolute",
                        top: 0,
                        right: 0,
                        transform: "translate(50%, -50%)",
                      }}
                      onClick={() => {
                        setFold3Image({ url: "", obj: "" });
                        setIsChanged(true);
                      }}
                    />
                    <img
                      src={fold3Image.url}
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      position: "relative",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    <input
                      type="file"
                      style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        opacity: 0,
                      }}
                      accept="image/*"
                      onChange={(e) => {
                        setFold3Image({
                          url: URL.createObjectURL(e.target.files[0]),
                          obj: e.target.files[0],
                        });
                        setIsChanged(true);
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faPlus}
                      style={{ color: "var(--blue-dark)" }}
                    />
                  </div>
                )}
              </div>
              {fold3Image?.url && (
                <div className="grid_2">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Caption"}
                    value={fold3ImageCaption}
                    onChange={(e) => {
                      setFold3ImageCaption(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Alt"}
                    value={fold3ImageAlt}
                    onChange={(e) => {
                      setFold3ImageAlt(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                </div>
              )}
              <InputField
                type="text"
                isLabel={true}
                lable="Heading"
                value={fold3Heading}
                onChange={(e) => {
                  setFold3Heading(e.target.value);
                  setIsChanged(true);
                }}
              />

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setIsChanged(true);
                    setFold3Description(val);
                  }}
                  content={fold3Description}
                  smallEditor={true}
                />
              </div>

              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={fold3BtnShow}
                    onClick={() => {
                      setFold3BtnShow((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {fold3BtnShow && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      lable="Button Text"
                      value={fold3BtnText}
                      onChange={(e) => {
                        setFold3BtnText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable="Button Link"
                      value={fold3BtnLink}
                      onChange={(e) => {
                        setFold3BtnLink(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="card grid">
              <h3>Fold 4</h3>
              <div>
                <p style={{ fontSize: ".9rem" }}>Image</p>
                {fold4Image.url ? (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                      position: "relative",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faClose}
                      style={{
                        color: "var(--blue-dark)",
                        cursor: "pointer",
                        height: "15px",
                        width: "15px",
                        padding: "5px",
                        position: "absolute",
                        top: 0,
                        right: 0,
                        transform: "translate(50%, -50%)",
                      }}
                      onClick={() => {
                        setFold4Image({ url: "", obj: "" });
                        setIsChanged(true);
                      }}
                    />
                    <img
                      src={fold4Image.url}
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      position: "relative",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    <input
                      type="file"
                      style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        opacity: 0,
                      }}
                      accept="image/*"
                      onChange={(e) => {
                        setFold4Image({
                          url: URL.createObjectURL(e.target.files[0]),
                          obj: e.target.files[0],
                        });
                        setIsChanged(true);
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faPlus}
                      style={{ color: "var(--blue-dark)" }}
                    />
                  </div>
                )}
              </div>
              {fold4Image?.url && (
                <div className="grid_2">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Caption"}
                    value={fold4ImageCaption}
                    onChange={(e) => {
                      setFold4ImageCaption(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Alt"}
                    value={fold4ImageAlt}
                    onChange={(e) => {
                      setFold4ImageAlt(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                </div>
              )}
              <InputField
                type="text"
                isLabel={true}
                lable="Heading"
                value={fold4Title}
                onChange={(e) => {
                  setFold4Title(e.target.value);
                  setIsChanged(true);
                }}
              />

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setIsChanged(true);
                    setFold4Description(val);
                  }}
                  content={fold4Description}
                  smallEditor={true}
                />
              </div>

              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={fold4BtnShow}
                    onClick={() => {
                      setFold4BtnShow((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {fold4BtnShow && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      lable="Button Text"
                      value={fold4BtnText}
                      onChange={(e) => {
                        setFold4BtnText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable="Button Link"
                      value={fold4BtnLink}
                      onChange={(e) => {
                        setFold4BtnLink(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="card grid">
              <InputField
                isLabel={true}
                lable="Slug"
                value={slug}
                onChange={(e) => {
                  setSlug(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Title"
                value={metaTitle}
                onChange={(e) => {
                  setMetaTitle(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Image Url"
                value={metaImageUrl}
                onChange={(e) => {
                  setMetaImageUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Description"
                value={metaDescription}
                onChange={(e) => {
                  setMetaDescription(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Canonical Url"
                value={canonicalUrl}
                onChange={(e) => {
                  setCanonicalUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default Career;
